import gameData from "../../gameData.js";
import trayBaseSlider from './trayBaseSlider.js';

export default class FaceTray extends trayBaseSlider
{
    constructor(scene, parentCont, type, ind)
    {
        super(scene, parentCont, type, ind);

        this.scene = scene;
        this.pCont = parentCont;
        this.type = type;
        this.ind = ind;

        this.createFaceTray();

        this.setPosition(0, 0);
        this.scene.addToParent(this, this.pCont);
    }

    createFaceTray()
    {
        for(let i=1;i<=6;i++){
            let face = this.scene.addButton(0, 0, "Btn_Face"+i, null, ()=>{
                this.scene.playSound("select_color_pattern_face");
                
                gameData.bgColor = null;

                this.scene.navbar.clearActiveTrays();
                this.isActive = true;

                this.scene.faceMask.setPattern();
                this.scene.faceMask.setFace(face.id);
                
                this.tweenInCursor(face);
            });
            face.id = i-1;
            face.x = 55;
            face.y = -440 + (118*i);
            
            this.addAt(face, 0);
            this.accessories.push(face);
        }
    }

    cleanUp()
    {
        this.cursor.destroy();
        this.accessories.forEach(face => {face.destroy();});
        this.nameplate.destroy();
        this.nameplateText.destroy();
    }
}